import React, { useState, useEffect } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import { useSelector, useDispatch } from "react-redux";
import ContentLoader from "react-content-loader";
import useDarkMode from "@fisch0920/use-dark-mode";
import axios from "axios";
import {
  loadingPrijemOdJinePobockyTable,
  prijemOdJinePobockyTable,
  prijemOdJinePobockyTableData,
  setZaznamy,
} from "./redux/tablePrijemOdJinePobockySlice";
import { loginData } from "../../../SignIn/redux/loginSlice";
import { searchData } from "../../../../components/Search/redux/searchSlice";
import {
  DataGridPremium,
  GridCellEditStopReasons,
  LicenseInfo,
  csCZ,
  useGridApiRef,
} from "@mui/x-data-grid-premium";
import { getLicensePremium } from "../../../../features/License";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  formRunUrl,
  trellisKategorieUrl,
  trellisdaj_custom_fieldsUrl,
} from "../../../../features/urlHelper";
import { errorHandleDialog } from "../../../../features/errorDialog";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalForm from "./../../../../components/Modaly/ModalForm";
import ModalZaznamyProblemov from "./../../../../components/Modaly/ModalZaznamyProblemov";
import {
  Form,
  loadingForm,
  FormData,
} from "../../../../components/Modaly/ModalForm/redux/FormSlice";
import swal from "sweetalert";

const Table = ({
  className,
  activeTable,
  editPsOver,
  setEditPsOver,
  visibleZaznamyProblemov,
  setVisibleZaznamyProblemov,
  zobrazTrellis,
  setZobrazTrellis,
  priznak,
}) => {
  const apiRef = useGridApiRef();
  const darkMode = useDarkMode(false);
  const [rowGroupingModel, setRowGroupingModel] = React.useState([
    "skupina_nazov",
  ]);
  const [value, setValue] = React.useState(0);
  const [valueId, setValueId] = React.useState("");
  const [valueField, setValueField] = React.useState("");
  const notify_info = (text) => toast.info(text);
  const notify_error = (text) => toast.error(text);
  const navigate = useHistory();
  const dispatch = useDispatch();
  const [formName, setFormName] = useState("");
  const [zaznamZnacka, setZaznamZnacka] = useState("");
  const [visibleForm, setVisibleForm] = useState(false);
  //const logindata = useSelector(loginData);
  const logindata = JSON.parse(
    window.sessionStorage.getItem("logindata") !== null
      ? window.sessionStorage.getItem("logindata")
      : "{}"
  );
  const Formdata = useSelector(FormData);
  const prijemOdJinePobockyTabledata = useSelector(
    prijemOdJinePobockyTableData
  );
  const searchdata = useSelector(searchData);
  LicenseInfo.setLicenseKey(getLicensePremium());

  function getWidth(width) {
    if (width > 2500) {
      return width - 456;
    } else if (width < 2500 && width > 767) {
      return width - 192;
    } else {
      return width - 48;
    }
  }
  const removeZaznam = (index) => {
    let data = [...prijemOdJinePobockyTabledata.zaznamy];
    data.splice(index, 1);
    //console.log(data);
    dispatch(setZaznamy(data));
  };

  function isInt(n) {
    return n % 1 === 0;
  }

  function RespoPodlaPrijmu(n) {
    return priznak === "Other" ? n - 35 : n + 35;
  }

  useEffect(() => {
    call_form("new");
  }, []);

  async function ziskaj_kategorie(volba, data = null) {
    await axios
      .post(
        trellisdaj_custom_fieldsUrl,
        {
          username:
            logindata.UserData.fakeusername !== undefined
              ? logindata.UserData.fakeusername
              : logindata.UserData.username,
          stredisko: logindata.UserData.vybrane_stredisko.kod,
        },
        {
          headers: { Authorization: "Bearer " + logindata.Token },
        }
      )
      .then(function (response) {
        var varpol9 = {
          ...data.varpol9,
          value: JSON.stringify(response.data.kategorie),
        };
        var varpol19 = {
          ...data.varpol19,
          value: JSON.stringify(response.data.lokality),
        };
        var varpol29 = {
          ...data.varpol29,
          value: JSON.stringify(response.data.cielove_lokality),
        };
        call_form(volba, {
          ...data,
          varpol9: varpol9,
          varpol19: varpol19,
          varpol29: varpol29,
        });
      })
      .catch(function (error) {
        console.log(error);
        errorHandleDialog(error.response, navigate, dispatch);
      });
  }

  async function call_form(volba, data = null) {
    console.log(data);
    await axios
      .post(
        formRunUrl,
        {
          formName: "ZaznamProblemu",
          formValues: data,
          volba: volba,
        },
        {
          headers: { Authorization: "Bearer " + logindata.Token },
        }
      )
      .then(function (response) {
        if (response.data.typ === "route") {
          navigate.push(response.data.url);
        } else if (response.data.typ === "enter") {
          console.log("enterData", response.data.enterData);
          dispatch(loadingForm());
          setFormName(response.data.enterData.formName);
          dispatch(Form(response.data.enterData));
          if (volba === "edit") setVisibleForm(true);
          if (document.getElementsByName("varpol4")[0] !== undefined) {
            document.getElementsByName("varpol4")[0].focus();
            document.getElementsByName("varpol4")[0].select();
          }
        }
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
        errorHandleDialog(error.response, navigate, dispatch);
      });
  }

  const stylingTable = {
    border: 0,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    letterSpacing: "normal",
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
      color: darkMode.value ? "white" : "#666d74",
      borderRight: `1px solid ${darkMode.value ? "white" : "#e0e0e0"}`,
    },
    "& .MuiDataGrid-overlay": {
      backgroundColor: "transparent",
      color: darkMode.value ? "white" : "#ACACAC",
    },
    "& .MuiInputBase-input": {
      color: darkMode.value ? "black" : "#ACACAC",
    },
    "& .MuiSvgIcon-root": {
      color: "#a7acaf",
    },
    "& .MuiDataGrid-cell--editable": {
      color: "black",
      backgroundColor: "rgb(195, 247, 195)",
      "&:hover": {
        backgroundColor: "rgb(240,250,190)",
      },
      "& .MuiInputBase-root": {
        height: "100%",
      },
    },
    "& .MuiDataGrid-cell--editing": {
      color: "black",
    },
    "& .MuiDataGrid-cell": {
      paddingRight: "8px",
    },
    "& .action": {
      padding: 0,
    },
    "& .action1": {
      padding: 0,
    },
    "& .action2": {
      padding: 0,
    },
    "& .MuiDataGrid-groupingCriteriaCell": {
      fontSize: "smaller",
      //customElements: (<div>aaa</div>),
    },
    "& .Mui-error": {
      backgroundColor: "red",
      color: "white",
    },
    width: getWidth(window.innerWidth),
    height:
      window.innerWidth < 767
        ? window.innerHeight - 350
        : window.innerHeight - 371,
    display: "flex",
    justifyContent: "center",
    alighnItems: "center",
  };

  const theme = createTheme({
    palette: {
      primary: { main: "#F1B600" },
    },
  });

  const columns = [
    {
      field: "skupina_nazov",
      headerName: "Skupina",
      width: window.innerWidth < 767 ? 180 : 280,
      groupable: true,
      sortable: false,
      cellClassName: "action",
    },
    {
      field: "nazov",
      headerName: "Položka",
      cellClassName: "action",
      width: 280,
      groupable: false,
      renderCell: (params) => (
        <>
          <div className={styles.nazov}>
            <div className={styles.avatar2}>
              <img src={"/images/content/bageta2.png"} alt="Avatar" />
            </div>
            <div className={styles.nazov_kod}>
              <div> {params.row.nazov} </div>
              <div className={styles.znacka}>
                <div className={styles.znackaText}> {params.row.znacka} </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      field: "mnozstvo",
      headerName: "Zaslané",
      width:
        (getWidth(window.innerWidth) -
          (window.innerWidth > 767
            ? RespoPodlaPrijmu(350)
            : RespoPodlaPrijmu(230))) *
        (window.innerWidth > 767 ? 0.2 : 0.4),
      minWidth: window.innerWidth < 767 ? 55 : 90,
      type: "number",
      headerAlign: "center",
      sortable: false,
      valueFormatter: (params) => {
        if (params.value === undefined) {
          return `${""}`;
        }
        const valueFormatted = Number(params.value);

        const value = valueFormatted
          .toFixed(0)
          .replace(/(\d)(?=(\d{3})+\b)/g, "$1 ");
        //console.log(value);
        return `${value}`;
      },
      renderCell: (params) => {
        return <div className={styles.nazov_kod}>{params.value}</div>;
      },
    },
    {
      field: "prijate",
      headerName: "Prijaté",
      width:
        (getWidth(window.innerWidth) -
          (window.innerWidth > 767
            ? RespoPodlaPrijmu(350)
            : RespoPodlaPrijmu(230))) *
        (window.innerWidth > 767 ? 0.2 : 0.4),
      editable: false,
      minWidth: window.innerWidth < 767 ? 55 : 90,
      type: "number",
      headerAlign: "center",
      sortable: false,
      // valueFormatter: (params) => {
      //   const valueFormatted = Number(params.value);

      //   const value = valueFormatted
      //     .toFixed(2)
      //     .replace(/(\d)(?=(\d{3})+\b)/g, "$1 ");

      //   return `${value}`;
      // },
      renderCell: (params) => {
        return <div className={styles.nazov_kod}>{params.value}</div>;
      },
      preProcessEditCellProps: (params) => {
        const hasError =
          params.props.value < 0 || params.row.mnozstvo < params.props.value;
        if (hasError) {
          if (params.props.value < 0) {
            notify_error("Počet musí být větší než 0!");
          }
          if (params.row.mnozstvo < params.props.value) {
            notify_error("Počet nesmí přesáhnout zaslané položky!");
          }
        }
        return { ...params.props, error: hasError };
      },
    },
    {
      field: "mj",
      headerName: "Mj",
      width:
        (getWidth(window.innerWidth) -
          (window.innerWidth > 767
            ? RespoPodlaPrijmu(350)
            : RespoPodlaPrijmu(230))) *
        (window.innerWidth > 767 ? 0.1 : 0.2),
      minWidth: window.innerWidth < 767 ? 40 : 60,
      editable: false,
      sortable: false,
      headerAlign: "center",
      renderCell: (params) => {
        return <div className={styles.nazov_kod}>{params.value}</div>;
      },
    },
    {
      field: "komentar",
      headerName: "Komentář",
      width: (getWidth(window.innerWidth) - 350) * 0.5,
      minWidth: 180,
      editable: false,
      headerAlign: "center",
      preProcessEditCellProps: (params) => {
        const hasError = false;

        if (hasError) {
          console.log(hasError);
        }
        return { ...params.props, error: hasError };
      },
      renderCell: (params) => {
        return <div className={styles.nazov_kod}>{params.value}</div>;
      },
    },

    {
      cellClassName: "action1",
      field: "stav",
      headerName: "",
      width: 70,
      sortable: false,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params.value !== undefined ? (
            <div className={styles.avatars}>
              <div
                title={
                  !params.row.problem
                    ? "Záznam problému"
                    : "Zrušit záznam problému"
                }
                onClick={() => {
                  if (params.row.problem) {
                    swal({
                      title: "Chcete smazat Záznam problému?",
                      icon: "info",
                      buttons: ["Ne ", "Ano"],
                      dangerMode: true,
                    }).then(async (willShow) => {
                      if (willShow) {
                        var riadok = prijemOdJinePobockyTabledata.zaznamy.find(
                          (x) => x.znacka.trim() === params.row.znacka.trim()
                        );
                        removeZaznam(
                          prijemOdJinePobockyTabledata.zaznamy.indexOf(riadok)
                        );
                        const new_data = prijemOdJinePobockyTabledata.data.map(
                          (x) => {
                            if (x.id === params.row.znacka)
                              return {
                                ...x,
                                problem: false,
                                prijate: 0,
                                skupina_nazov: params.row.skupina_nazov_old,
                                sort_col: 0,
                                komentar: "",
                              };
                            else return x;
                          }
                        );
                        //console.log(new_data)
                        // apiRef.current.subscribeEvent(
                        //   "sortModelChange",
                        //   handleEvent
                        // );
                        dispatch(prijemOdJinePobockyTable(new_data));
                      }
                    });
                  } else {
                    var varpol1 = {
                      ...Formdata.data.values.varpol1,
                      value: params.row.znacka,
                      selectorLabel: params.row.nazov,
                    };
                    var varpol2 = {
                      ...Formdata.data.values.varpol2,
                      value: params.row.mnozstvo,
                    };
                    var varpol3 = {
                      ...Formdata.data.values.varpol3,
                      value: params.row.mj,
                    };
                    var varpol4 = {
                      ...Formdata.data.values.varpol4,
                      value: params.row.prijate,
                    };
                    var varpol5 = {
                      ...Formdata.data.values.varpol5,
                      value: params.row.mj,
                    };
                    var varpol6 = {
                      ...Formdata.data.values.varpol6,
                      value: "",
                    };
                    var varpol7 = {
                      ...Formdata.data.values.varpol7,
                      value: "",
                    };
                    var varpol17 = {
                      ...Formdata.data.values.varpol17,
                      value: "",
                    };
                    var varpol27 = {
                      ...Formdata.data.values.varpol27,
                      value: "",
                    };
                    var varpol8 = {
                      ...Formdata.data.values.varpol8,
                      value: false,
                    };
                    var varpol9 = {
                      ...Formdata.data.values.varpol9,
                      value: "",
                    };
                    var varpol19 = {
                      ...Formdata.data.values.varpol19,
                      value: "",
                    };
                    var varpol29 = {
                      ...Formdata.data.values.varpo29,
                      value: "",
                    };
                    var varpol10 = {
                      ...Formdata.data.values.varpo29,
                      value: logindata.UserData.vybrane_stredisko.kod,
                    };
                    var varpol11 = {
                      ...Formdata.data.values.varpo21,
                      value: [],
                    };
                    var data = {
                      varpol1: varpol1,
                      varpol2: varpol2,
                      varpol3: varpol3,
                      varpol4: varpol4,
                      varpol5: varpol5,
                      varpol6: varpol6,
                      varpol7: varpol7,
                      varpol17: varpol17,
                      varpol27: varpol27,
                      varpol8: varpol8,
                      varpol9: varpol9,
                      varpol19: varpol19,
                      varpol29: varpol29,
                      varpol10: varpol10,
                      varpol11: varpol11,
                    };
                    ziskaj_kategorie("edit", data);
                    setZaznamZnacka(params.row.znacka);
                  }
                }}
                className={
                  params.row.problem
                    ? styles.avatar_problemA
                    : styles.avatar_problemP
                }
              >
                <div> ! </div>
              </div>
              <div
                title={
                  !params.row.stav
                    ? params.row.problem
                      ? "Nelze potvrdit skrz Záznam problému!"
                      : "Potvrzení příjmu"
                    : "Zrušení příjmu"
                }
                onClick={() => {
                  if (!params.row.problem) {
                    if (params.row.stav) {
                      swal({
                        title: "Chcete zrušit příjem?",
                        icon: "info",
                        buttons: ["Ne ", "Ano"],
                        dangerMode: true,
                      }).then(async (willShow) => {
                        if (willShow) {
                          const new_data =
                            prijemOdJinePobockyTabledata.data.map((x) => {
                              if (x.id === params.row.id)
                                return {
                                  ...x,
                                  stav: !params.row.stav,
                                  prijate: 0,
                                  skupina_nazov: params.row.skupina_nazov_old,
                                  sort_col: 0,
                                };
                              else return x;
                            });
                          dispatch(prijemOdJinePobockyTable(new_data));
                        }
                      });
                    } else {
                      const new_data = prijemOdJinePobockyTabledata.data.map(
                        (x) => {
                          if (x.id === params.row.id)
                            return {
                              ...x,
                              stav: !params.row.stav,
                              prijate: params.row.mnozstvo,
                              skupina_nazov: "2. Přijato - OK",
                              skupina_nazov_old:
                                params.row.default_skupina_nazov,
                              sort_col: 2,
                            };
                          else return x;
                        }
                      );
                      dispatch(prijemOdJinePobockyTable(new_data));
                    }
                  }
                }}
                className={
                  params.row.stav
                    ? styles.avatar_checkA
                    : params.row.problem
                    ? styles.avatar_bezHover
                    : styles.avatar_checkP
                }
              >
                <div>
                  <i class="fa fa-check"> </i>
                </div>
              </div>
            </div>
          ) : (
            <> </>
          )}
        </>
      ),
    },
    {
      cellClassName: "action2",
      field: "stav",
      headerName: "",
      minWidth: 35,
      width: 35,
      sortable: false,
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <>
            {params.value !== undefined ? (
              <div className={styles.avatars2}>
                <div
                  title={
                    !params.row.stav ? "Potvrzení příjmu" : "Zrušení příjmu"
                  }
                  onClick={() => {
                    if (params.row.stav) {
                      swal({
                        title: "Chcete zrušit příjem?",
                        icon: "info",
                        buttons: ["Ne ", "Ano"],
                        dangerMode: true,
                      }).then(async (willShow) => {
                        if (willShow) {
                          const new_data =
                            prijemOdJinePobockyTabledata.data.map((x) => {
                              if (x.id === params.row.id)
                                return {
                                  ...x,
                                  stav: !params.row.stav,
                                  prijate: 0,
                                  skupina_nazov: params.row.skupina_nazov_old,
                                  sort_col: 0,
                                };
                              else return x;
                            });
                          dispatch(prijemOdJinePobockyTable(new_data));
                        }
                      });
                    } else {
                      swal({
                        title: "Chcete položku opravdu přijmout?",
                        icon: "info",
                        buttons: ["Ne ", "Ano"],
                      }).then(async (willShow) => {
                        if (willShow) {
                          const new_data =
                            prijemOdJinePobockyTabledata.data.map((x) => {
                              if (x.id === params.row.id)
                                return {
                                  ...x,
                                  stav: !params.row.stav,
                                  prijate: params.row.mnozstvo,
                                  skupina_nazov: "2. Přijato - OK",
                                  skupina_nazov_old:
                                    params.row.default_skupina_nazov,
                                  sort_col: 2,
                                };
                              else return x;
                            });
                          dispatch(prijemOdJinePobockyTable(new_data));
                        }
                      });
                    }
                  }}
                  className={
                    params.row.stav
                      ? styles.avatar_checkA
                      : styles.avatar_checkP
                  }
                >
                  <div>
                    <i class="fa fa-check"> </i>
                  </div>
                </div>
              </div>
            ) : (
              <> </>
            )}
          </>
        );
      },
    },
  ].filter((x) => {
    if (window.innerWidth > 767) {
      if (priznak === "Other" && x.cellClassName === "action1") {
      } else if (priznak === "Zizelice" && x.cellClassName === "action2") {
      } else {
        return x;
      }
    } else {
      if (x.field !== "komentar") {
        if (priznak === "Other" && x.cellClassName === "action1") {
        } else if (priznak === "Zizelice" && x.cellClassName === "action2") {
        } else {
          return x;
        }
      }
    }
  });

  return (
    <div className={cn(styles.wrapper1, className)}>
      {prijemOdJinePobockyTabledata.loading ? (
        <ContentLoader
          speed={2}
          width={"100%"}
          height={300}
          backgroundColor={darkMode.value ? "#1e2730" : "#f3f3f3"}
          foregroundColor={darkMode.value ? "#2d3641" : "#ecebeb"}
        >
          <rect x="3%" y="5%" rx="3" ry="3" width={"100%"} height="80%" />
        </ContentLoader>
      ) : (
        <div className={cn(styles.wrapper, className)}>
          <ThemeProvider theme={theme}>
            <DataGridPremium
              sx={stylingTable}
              ref={apiRef}
              localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
              {...{
                rows: prijemOdJinePobockyTabledata.data,
                columns: columns,
              }}
              slotProps={{
                row: {
                  onFocus: (event) => {
                    setValueId(event.currentTarget.getAttribute("data-id"));
                  },
                },
                cell: {
                  onFocus: (event) => {
                    setValueField(
                      event.currentTarget.getAttribute("data-field")
                    );
                  },
                },
              }}
              defaultGroupingExpansionDepth={-1}
              columnHeaderHeight={25}
              disableAutoFocus
              disableColumnMenu
              disableColumnReorder
              hideFooter
              rowHeight={40}
              onCellEditStart={(params, event) => {
                console.log("onCellEditStart", editPsOver);
                let zoznam_cell = editPsOver;
                if (
                  editPsOver.filter(
                    (cell) => cell.cell === valueId + valueField
                  )[0] === undefined
                ) {
                  zoznam_cell.push({ cell: valueId + valueField, over: false });
                  //console.log(zoznam_cell);
                  setEditPsOver(zoznam_cell);
                } else {
                  let new_zoznam_cell = [];
                  zoznam_cell.map((cell) => {
                    cell.cell === valueId + valueField
                      ? new_zoznam_cell.push({
                          cell: valueId + valueField,
                          over: false,
                        })
                      : new_zoznam_cell.push(cell);
                  });
                  console.log(new_zoznam_cell);
                  setEditPsOver(new_zoznam_cell);
                }
              }}
              onCellEditStop={async function (params, event) {
                //event.defaultMuiPrevented = true;
                if (params.reason === GridCellEditStopReasons.cellFocusOut) {
                  event.defaultMuiPrevented = true;
                  notify_info(
                    "Pokud chcete potvrdit množství do tabulky stiskněte enter!"
                  );
                } else {
                  let row = prijemOdJinePobockyTabledata.data.filter(
                    (row) => row.id === params.id
                  );
                  let index = prijemOdJinePobockyTabledata.data.indexOf(row[0]);
                  let data = [...prijemOdJinePobockyTabledata.data];
                  let row_copy = { ...row[0] };
                  if (params.colDef.type === "number") {
                    console.log(params);
                    if (Number(event.target.value) === params.row.mnozstvo) {
                      row_copy.stav = true;
                      row_copy[params.field] = Number(event.target.value);
                    } else {
                      row_copy[params.field] = Number(event.target.value);
                      row_copy.stav = false;
                    }
                  } else {
                    row_copy[params.field] = event.target.value;
                    row_copy.stav = false;
                  }
                  data[index] = row_copy;
                  console.log(row_copy);
                  console.log(data);
                  dispatch(loadingPrijemOdJinePobockyTable());
                  dispatch(prijemOdJinePobockyTable(data));

                  let zoznam_cell = [];
                  editPsOver.map((cell) => {
                    cell.cell === valueId + valueField
                      ? zoznam_cell.push({
                          cell: valueId + valueField,
                          over: true,
                        })
                      : zoznam_cell.push(cell);
                  });
                  console.log(zoznam_cell);
                  setEditPsOver(zoznam_cell);
                }
              }}
              onRowGroupingModelChange={(model) => setRowGroupingModel(model)}
              isCellEditable={(params) => {
                return !params.row.stav && !params.row.problem;
              }}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    skupina_nazov: false,
                    nazov: false,
                  },
                },
              }}
              sortingOrder={["desc", "asc"]}
              sortModel={[
                { field: "__row_group_by_columns_group__", sort: "asc" },
              ]}
              groupingColDef={{
                width: window.innerWidth < 767 ? 160 : 280,
                leafField: "nazov",
                headerName: "Položka",
                //sortable: true,
                mainGroupingCriteria: "skupina_nazov",
                renderCell: (params) => (
                  <>
                    {!params.id.includes("auto-generated") ? (
                      <div className={styles.nazov}>
                        {window.innerWidth > 767 ? (
                          <div className={styles.avatar2}>
                            <img
                              src={"/images/content/bageta2.png"}
                              alt="Avatar"
                            />
                          </div>
                        ) : (
                          <> </>
                        )}
                        <div className={styles.nazov_kod}>
                          <div> {params.row.nazov} </div>
                          <div className={styles.znacka}>
                            <div className={styles.znackaText}>
                              {params.row.znacka}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className={styles.groupe}>
                        <div className={styles.icon_grp}>
                          <i class="fas fa-angle-down"> </i>
                        </div>
                        {params.value === "1. Přijato - Se záznamem" ? (
                          <div className={styles.text_red}>
                            {params.value.slice(3)}
                          </div>
                        ) : params.value === "2. Přijato - OK" ? (
                          <div className={styles.text_green}>
                            {params.value.slice(3)}
                          </div>
                        ) : (
                          <div> {params.value.slice(3)} </div>
                        )}
                      </div>
                    )}
                  </>
                ),
              }}
              rowGroupingModel={rowGroupingModel}
            />
          </ThemeProvider>
        </div>
        // </div>
      )}
      <ModalForm
        priznak="zaznamProblemu"
        visible={visibleForm}
        setVisible={setVisibleForm}
        className={styles}
        formName={formName}
        znacka={zaznamZnacka}
      />
      <ModalZaznamyProblemov
        visible={visibleZaznamyProblemov}
        setVisible={setVisibleZaznamyProblemov}
        className={styles}
        data={prijemOdJinePobockyTabledata.zaznamy}
        zobrazTrellis={zobrazTrellis}
        setZobrazTrellis={setZobrazTrellis}
        //setMyFiles={setMyFiles}
      />
      <ToastContainer />
    </div>
  );
};

export default Table;
